const checkAccessDenied = (error: any): boolean => {
  return error.data?.error.hasOwnProperty('AccessDenied') || false
}

export default checkAccessDenied
